import { Camera } from "./Camera";
import { mat4, vec3 } from "gl-matrix";
import { ViewPort } from "./ViewPort";
import { toRadian } from "@spi/Common/Math";

export class FreeViewCamera extends Camera {

    private _position: vec3;
    private _rotation: number;

    constructor(viewPort: ViewPort) {
        super(viewPort);
        this._rotation = 0;
        this._position = vec3.create();
    }

    public get position(): vec3 {
        return this._position;
    }

    public get rotation(): number {
        return this._rotation;
    }

    public set rotation(value: number) {
        this._rotation = value;
        this.invalidatedModelView = true;
    }

    public get x(): number {
        return this._position[0];
    }

    public set x(value: number) {
        this._position[0] = value;
        this.invalidatedModelView = true;
    }

    public get y(): number {
        return this._position[1];
    }

    public set y(value: number) {
        this._position[1] = value;
        this.invalidatedModelView = true;
    }

    public get z(): number {
        return this._position[2];
    }

    public set z(value: number) {
        this._position[2] = value;
        this.invalidatedModelView = true;
    }

    protected applyModelView(matrix: mat4): void {
        let rotation = this.rotation % 360;

        /*
        var pitch = this.lookDirection;
        var yaw = -this.rotation;
        
        mat4.rotate(matrix, matrix, glMatrix.toRadian(-pitch), [1, 0, 0]);
        mat4.rotate(matrix, matrix, glMatrix.toRadian(-yaw), [0, 1, 0]);
    	
        mat4.rotate(matrix, matrix, glMatrix.toRadian(90.0), [1, 0, 0]);
    	
        mat4.translate(matrix, matrix, vec3.fromValues(-this.x, -this.y, -this.z));*/

        let dist = 25;

        mat4.lookAt(matrix,
            vec3.fromValues( // camera
                this.x + dist * Math.sin(toRadian(rotation)), // rotate around the location
                this.y + dist * Math.cos(toRadian(rotation)),
                this.z + 10 // Up in the air a bit
            ),
            this._position, // location
            vec3.fromValues(0, 0, 1) // z is up
        );
    }

    public prepareFrame(): void {

    }

}